<!-- 人才政策 -->
<template>
  <div>
    <BannerJoinUs :bg="info[0] ? info[0].pic : ''" :status="info[0] ? info[0].status : '1'" />
    <div class="container-1600 pt-[35px]">
      <div class="flex items-center">
        <span>当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="!text-[16px]">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>人才服务</el-breadcrumb-item>
          <el-breadcrumb-item>人才政策</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="mb-[30px] mt-[42px] flex justify-center">
        <el-radio-group v-model="cate" style="margin-bottom: 30px" @input="cateChangeEvent">
          <el-radio-button v-for="(item, key) in talentPolicyCate" :key="key" :label="item.t_id" class="lt-md:w-full lt-md:mb-[10px]">
            {{ item.title }}
          </el-radio-button>
        </el-radio-group>
      </div>

      <div class="flex flex-wrap">
        <TalentPolicyCard class="w-[50%] px-[15px] pb-[30px] lt-lg:w-full" v-for="(item, key) in talentPolicyList.list" :key="key" :detail="item"></TalentPolicyCard>
      </div>

      <div class="mt-[40px] text-center">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="talentPolicyList.total"
          :page-size="talentPolicyList.pageSize"
          @current-change="handlePageChange"
          class="inline-block"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BannerJoinUs from '@/components/BannerJoinUs.vue';
import TalentPolicyCard from '@/components/TalentPolicyCard.vue';

import { talentPolicyCate, talentPolicyList } from '@/api/article';

export default {
  name: 'TalentPolicy',
  components: {
    BannerJoinUs,
    TalentPolicyCard,
  },
  data() {
    return {
      cate: 1,
      talentPolicyCate: [{}, {}, {}],
      talentPolicyList: {
        total: 0,
        pageSize: 8,
        currentPage: 1,
        list: [
          {
            talent_policy_id: '',
            title: '',
            description: '',
            detail: '',
            keyword: '',
            jumpurl: '',
            sortid: '',
            status: '',
            create_time: '',
            update_time: '',
          },
        ],
      },
    };
  },
  methods: {
    // 获取列表数据
    getData() {
      talentPolicyCate().then((res) => {
        this.talentPolicyCate = res.data.list.sort((a, b) => Number(a.sortid) - Number(b.sortid));

        if (!this.cate) {
          this.cate = this.talentPolicyCate[0].t_id;
        }
        this.cateChangeEvent(this.cate);
      });
    },
    // 页码改变
    handlePageChange(currentPage) {
      console.log(currentPage);
      this.talentPolicyList.currentPage = currentPage;
      this.getData();
    },
    handleChange() {
      this.getData();
    },
    cateChangeEvent(t_id) {
      talentPolicyList({ limit: this.talentPolicyList.pageSize, page: this.talentPolicyList.currentPage, t_id }).then(
        (res) => {
          const data = res.data;

          data.rows.map((item) => {
            item.detail = item.detail.replace(/<[^>]+>/g, '');
            return item;
          });

          this.talentPolicyList.list = data.rows;
          this.talentPolicyList.total = data.total;
        },
      );
    },
  },
  mounted() {
    this.handleChange();
    this.cate = localStorage.getItem('talenPolicyCate'); // 返回页面时分类回显
  },
  watch: {
    $route: 'handleChange',
  },
  computed: {
    info() {
      let temp = this.$store.state.navCate.filter((item) => {
        if (item.resmenu_id === '4') {
          return item;
        }
      });
      return temp;
    },
  },
  beforeRouteEnter(to, from, next) {
    // 非详情页进入，清除分类回显
    if (from.path !== '/detail') {
      localStorage.removeItem('talenPolicyCate');
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    // 存储分类回显
    localStorage.setItem('talenPolicyCate', this.cate);
    next();
  },
};
</script>

<style lang="scss" scoped>
// 覆盖radio group样式
::v-deep .el-radio-button__inner {
  padding: 28px 64px 22px !important;
  font-size: 22px;
  border-radius: 0 !important;
  background: #edeeed !important;
  border: none !important;
  border-bottom: 6px solid #edeeed !important;
  box-shadow: none !important;
  transition: none !important;
}
::v-deep .is-active .el-radio-button__inner {
  color: #fff !important;
  border-bottom: 6px solid #016cc6 !important;
  background: url('@/assets/images/zc-switch-bg.jpg') no-repeat center/100% 100% !important;
}

@media screen and (max-width: 768px){
  ::v-deep  .el-radio-button__inner{
      width: 100%;
    }
}
</style>
